import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { queryClient } from '@/App.tsx';
import bookingSummaryApi from '@/features/public/bookingSummary/api/bookingSummaryApi.ts';
import { bookingSummaryApiQueryKeys } from '@/features/public/bookingSummary/api/bookingSummaryApi.queryKeys.ts';
import { BookingPublicSummaryDto } from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';

interface AcceptConsentParams {
  orgSlug: string;
  tourConsentId: string;
  token: string;
}

export const useAcceptConsent = () => {
  return useMutation<BookingPublicSummaryDto, Error, AcceptConsentParams>({
    mutationFn: ({ orgSlug, tourConsentId, token }) =>
      bookingSummaryApi.acceptConsent(orgSlug, tourConsentId, token),
    onSuccess: (data, { orgSlug, token }) => {
      queryClient.setQueryData(
        bookingSummaryApiQueryKeys.summary(orgSlug, token),
        data,
      );
      toast.success('Zaakceptowano dokument');
    },
    onError: (error) => {
      toast.error('Błąd', { description: error.message });
    },
  });
};
